const ITEMS = [
  "Touchdown to Skyline",
  "Luxury Trucks & Exotics",
  "Downtown Penthouse Stays",
  "Private Runway Pickup",
  "Atlanta, Georgia",
];

export const Marquee = () => {
  const row = (
    <>
      {ITEMS.map((item) => (
        <span key={item} className="mx-8 flex items-center gap-8">
          <span className="font-serif text-sm tracking-[0.25em] text-gold/60 uppercase">{item}</span>
          <span className="text-gold/40">◆</span>
        </span>
      ))}
    </>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-gold/10 bg-black/40 py-5"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        <div className="flex">{row}</div>
        <div className="flex">{row}</div>
      </div>
    </div>
  );
};
